import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export default class AuditStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'AuditStore',
			properties: [
				'audits',
				'adminAudits',
			],
		});
	}

	audits = [];
	adminAudits = [];

	reset = () => {
		this.audits = [];
		this.adminAudits = [];
	};

	setAudits = async state => {
		runInAction(() => {
			this.audits = state;
		});
	};

	setAdminAudits = async state => {
		runInAction(() => {
			this.adminAudits = state;
		});
	};
}